module.exports = __webpack_public_path__ + "static/media/TheGrandMayan.b380f381.png";